import HTTP from './http.service';

export const campaignService = {
  getDetail,
};

async function getDetail(key) {
  return await HTTP.get(`campaigns/keyword/${key}`);
}

